// @flow
import client from '../../client'

// API Endpoints
export const CUSTOMER_PROFILES_ENDPOINT = '/travel_agent/profiles/'

// Types
export type TCustomerProfile = {
  first_name: string,
  last_name: string,
  payment_option: {
    first_name: string,
    last_name: string,
    description: string,
    type: string,
    is_business: boolean,
    number: string,
    last4: string,
    exp_month: number,
    user: number,
    exp_year: number,
    stripe_customer_id: string,
    id: number,
    name: string,
  },
  country_code_name: string,
  phone_number_national: string,
  profile_name: string,
  id: number,
  email: string,
}

/**
 * Returns customer profiles of a TA user
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getCustomerProfiles = (data: {
  page?: number,
}): Promise<TCustomerProfile[]> => {
  const defaultValues = {
    page: 1,
  }
  const query = { ...defaultValues, ...data }
  return client.get(CUSTOMER_PROFILES_ENDPOINT, { query })
}

export default getCustomerProfiles
